import React from 'react';
import { Navigate } from 'react-router-dom';
import { backofficeUrl } from 'src/shared/helpers';

// Used for redirecting to the sales channel page if the link is still in some docs
export const BackgroundRecolorRedirect = () => {
    return <Navigate to={backofficeUrl('/tools/background-recolor')} replace />;
};
